import React from 'react';
import {locale} from '../locale/AppLocale'
import {Currencies} from './Currencies';
export const FormattedPrice = (price, className, currency) => {
    let defaultCurrency = Currencies().ils;
    if (!price) {
        price = 0;
    }

    if (currency && Currencies()[currency]) {
        defaultCurrency = Currencies()[currency];
    }
    const _formattedNumber = new Intl.NumberFormat("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);

    return <span className={`price ${className ? className : ''}`}>
            <span className="amount">{_formattedNumber}</span>
            <span className="notranslate symbol">{defaultCurrency.symbol}</span>
            <span className="currency">{defaultCurrency.title}</span>
        </span>
};

